import axios from 'axios';
import * as React from 'react';
import { ActionWrapper, IntuitWrapper, TrieWrapper } from './IntuitStyles';
import { language } from './IntuitLanguage';
import { CallToActionButtonLayout, Props as CTAProps } from '../../Components/CallToActionButton/CallToActionButtonLayout';
import { TrieLayout, Props as TrieProps } from './Layouts/Trie/TrieLayout';
import { ChartsLayout } from './Layouts/Charts/ChartsLayout';

export type Props = {
	categoryTrie: any;
	handleInvalidationCache: () => void;
	handleRepopulateCache: () => void;
	trieLoading: boolean;
};

export const IntuitLayout = (props: Props) => {
	const render = () => {
		const deleteCTAProps: CTAProps = {
			text: 'Invalidate Cache',
			onClick: props.handleInvalidationCache,
		};
		const createCTAProps: CTAProps = {
			text: 'Repopulate Cache',
			onClick: props.handleRepopulateCache,
		};
		const categoryTrieProps: TrieProps = {
			data: props.categoryTrie,
			loading: props.trieLoading,
		};

		const returnValue = (
			<IntuitWrapper>
				<ChartsLayout />
				{/*<ActionWrapper>*/}
				{/*	<CallToActionButtonLayout {...createCTAProps}/>*/}
				{/*	<CallToActionButtonLayout {...deleteCTAProps}/>*/}
				{/*</ActionWrapper>*/}
				{/*<TrieWrapper>*/}
				{/*	<TrieLayout {...categoryTrieProps}/>*/}
				{/*</TrieWrapper>*/}
			</IntuitWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
